import React, { useState, useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import { api } from '../../../api/apiService';
import { toast } from 'react-toastify';
import moment from 'moment';
import { Link } from 'react-router-dom';

function Payrolls() {
    const [payrolls, setPayrolls] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        fetchPayrollData();
    }, []);

    const fetchPayrollData = async () => {
        setIsLoading(true);
        try {
            const response = await api.get(`/payrolls`);
            setPayrolls(response.data.data.data);
        } catch (error) {
            console.error("Error fetching payroll data:", error);
            toast.error("Failed to fetch payroll data");
        } finally {
            setIsLoading(false);
        }
    };

    const formatNumber = (value) => {
        const roundedValue = Math.round(value * 10) / 10;
        return new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(roundedValue);
    };


    return (
        <>
            <main id="main" className="main">
                <div className="pagetitle d-flex justify-content-between align-items-center mb-4">
                    <h1>Payrolls</h1>
                </div>

                <section className="section">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    <h5 className="card-title">Payrolls</h5>
                                    {isLoading ? (
                                        <div className="text-center mt-3">
                                            <Spinner animation="border" variant="primary" />
                                            <span className="ms-2">Loading...</span>
                                        </div>
                                    ) : (
                                        <div className='table-responsive'>
                                            <table className='table'>
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Title</th>
                                                        <th>Total</th>
                                                        <th>Date Created</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {payrolls.length > 0 ? (
                                                        payrolls.map((payroll, index) => (
                                                            <tr key={payroll.id}>
                                                                <td>{index + 1}</td>
                                                                <td>
                                                                    <Link to={`${payroll.id}/details`}>{payroll.title}</Link>
                                                                </td>
                                                                <td>{formatNumber(payroll?.payroll_entries_sum_grand_total)}</td>
                                                                <td>{moment(payroll.created_at).format('DD-MM-YY ')}</td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="4" className="text-center">
                                                                No payrolls found.
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    );
}

export default Payrolls;
